"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTTCGRMMnemonics = exports.useTTCGRMContacts = exports.useTTCGRMAlerts = exports.TTCGRMProvider = exports.useTTCGRMActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ttc_grm_service_1 = require("../services/ttc-grm-service");
const TTCGRMContext = (0, react_1.createContext)(new ttc_grm_service_1.TTC_GRM_Service({ initial: 0, limit: 0 }));
const useTTCGRMActions = () => (0, react_1.useContext)(TTCGRMContext);
exports.useTTCGRMActions = useTTCGRMActions;
const TTCGRMProvider = ({ children, options }) => {
    const contactsService = new ttc_grm_service_1.TTC_GRM_Service(options);
    return ((0, jsx_runtime_1.jsx)(TTCGRMContext.Provider, { value: contactsService, children: children }));
};
exports.TTCGRMProvider = TTCGRMProvider;
const useTTCGRMAlerts = () => {
    const { subscribe, getSnapshot, transformData } = (0, exports.useTTCGRMActions)();
    const selectedData = (0, react_1.useSyncExternalStore)(subscribe, () => getSnapshot().alerts);
    const transformedData = transformData(selectedData);
    if (!transformedData)
        throw new Error('invalid data type selected');
    return transformedData;
};
exports.useTTCGRMAlerts = useTTCGRMAlerts;
const useTTCGRMContacts = () => {
    const { subscribe, getSnapshot, transformData } = (0, exports.useTTCGRMActions)();
    const selectedData = (0, react_1.useSyncExternalStore)(subscribe, () => getSnapshot().contacts);
    const transformedData = transformData(selectedData);
    if (!transformedData)
        throw new Error('invalid data type selected');
    return transformedData;
};
exports.useTTCGRMContacts = useTTCGRMContacts;
const useTTCGRMMnemonics = () => {
    const { subscribe, getSnapshot, transformData } = (0, exports.useTTCGRMActions)();
    const selectedData = (0, react_1.useSyncExternalStore)(subscribe, () => getSnapshot().mnemonics);
    const transformedData = transformData(selectedData);
    if (!transformedData)
        throw new Error('invalid data type selected');
    return transformedData;
};
exports.useTTCGRMMnemonics = useTTCGRMMnemonics;
